const config_prod = {
    api_url: "/api",
    file_url: "/api/business/common/static",
    web_url:  "https://lzwd.cc",
    loginType: 'wx'
}

//开发库配置
const config_dev = {
    api_url: "http://localhost:8980/api",
    file_url: "http://localhost:8980/api/common/static",
    web_url : "http://127.0.0.1",
    loginType: 'user'
}

// const config_dev = {
//     api_url: "https://lzwd.cc/api",
//     file_url: "https://lzwd.cc/api/common/static",
//     web_url : "http://127.0.0.1",
//     loginType: 'user'
// }

//测试库配置
const config_test = {
    api_url: "/api",
    file_url: "/api/common/static",
    web_url : "http://192.168.10.10:8000",
    loginType: 'user'
}

//const configData = config_test;
const configData = process.env.NODE_ENV === 'production' ? config_prod : config_dev;


export default {
    configData
};



// WEBPACK FOOTER //
// ./src/config/index.js